












































import Vue from "vue";
import { ModInterface } from "@/types/index";
import User from "../../../User";
export default Vue.extend({
  name: "ModlistEntry",
  props: {
    mod: {
      required: true,
      type: Object as () => ModInterface,
    },
    mutable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isModerator: false,
      updating: false,
    };
  },
  async mounted() {
    this.isModerator = await User.isModerator();
  },
  computed: {
    modLink(): string {
      return `https://steamcommunity.com/sharedfiles/filedetails/?id=${this.mod.workshopId}`;
    },
  },
  methods: {
    async updateMod(force: boolean = false) {
      this.updating = true;
      try {
        await this.axios.post("arma/mods/", force ? { ...this.mod, force: true } : this.mod);
      } finally {
        this.updating = false;
      }
    },
  },
});
